import { useAutoRoutingDE } from '../../../hooks/useAutoRouting/useAutoRoutingDE';

type TProps = {
  children?: React.ReactNode;
};

const StepRouterDE = ({ children }: TProps) => {
  useAutoRoutingDE();

  return <>{children}</>;
};

export default StepRouterDE;
